export default {
  getTranslated: (state) => (locale, submodule, key) => {
    let selections = state[submodule].selections;

    var selectionItemToBeGet = 'selectionValueEnglish';
    var translatedOptionsList = [];
    switch (locale.toLowerCase()) {
      case 'en_us':
        selectionItemToBeGet = 'selectionValueEnglish';
        break;
      case 'zh_hk':
        selectionItemToBeGet = 'selectionValueZhHk';
        break;
      case 'zh_cn':
        selectionItemToBeGet = 'selectionValueZhCn';
        break;
    }

    if (!selections) {
      return [];
    }

    let result = selections.filter((item) => {
      return key === item.name;
    }).map((item) => {
      return {
        name: item.name,
        options: item.options.map((item) => {
          return {
            value: item.selectionKey,
            text: item[selectionItemToBeGet]
          }
        })
      }
    });
    return result.length > 0 ? result[0].options : [];
  },
  getTranslatedArray: (state, getters) => (locale, submodule, key, haveAll = true) => {
    let result = getters.getTranslated(locale, submodule, key);
    if (result.length > 0) {
      if (haveAll) {
        result.unshift({ text: 'All', value: null });
      }
      return result;
    }

    return [];
  },
  getTranslatedValue: (state, getters) => (locale, submodule, type, key) => {
    if (!key) {
      return 'N/A';
    }
    let result = getters.getTranslatedArray(locale, submodule, type)
      .filter((item) => {
        return item.value === key
      });
    if (result.length > 0) {
      return result[0].text;
    }
    return 'N/A';
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js